module.exports = __webpack_public_path__ + "media/images/diy/arrow_up-28974b81a48647bded1b85b41d6f0a96.svg";